import "../assets/Heading.css";
import { jsx as r } from "preact/jsx-runtime";
import { c as a } from "./index.2w0W-O47.js";
const f = "_noMarginBottom_5hf8w_38", t = {
  "step--2": "_step--2_5hf8w_8",
  "step--1": "_step--1_5hf8w_12",
  "step-0": "_step-0_5hf8w_16",
  "step-1": "_step-1_5hf8w_20",
  "step-2": "_step-2_5hf8w_28",
  "step-3": "_step-3_5hf8w_32",
  "step-4": "_step-4_5hf8w_33",
  "step-5": "_step-5_5hf8w_34",
  noMarginBottom: f
}, w = ({
  element: _ = "h1",
  text: p = "",
  sizeStep: s = 0,
  children: o,
  removeMargin: n = !1,
  ...e
}) => /* @__PURE__ */ r(
  _,
  {
    ...e,
    class: a([
      t.text,
      t[`step-${s}`],
      /* use kebab-case class names for easier iteration, although camelCase is preferred */
      `pulse-step-${s}`,
      "pulse-type-strong",
      n && t.noMarginBottom,
      e.class
    ]),
    children: o || p
  }
);
export {
  w as H
};
